<form [formGroup]="expForm">
  <div class="row">
    <mat-accordion class="w-100" multi>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span>{{
              "user-registration.User_Details" | translate
            }}</span></mat-panel-title
          >
        </mat-expansion-panel-header>
        <div class="col-md-12">
          <div class="row">
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-1">
              <fieldset class="h-100 d-flex align-items-center">
                <legend>
                  {{ "user-registration.Display_Picture" | translate }}
                </legend>
                <div class="center">
                  <dg-file-upload
                    [title]="profileAttachTitle"
                    (finalPath)="onFinalPathForProfile($event)"
                    [profileAttachment]="isProfileComponent"
                    [acceptedType]="profileAcceptedType"
                    [maxSize]="profileMaxSize"
                    [uniqueAttachmentId]="profileUniqueAttachID"
                    [allowFileToAttach]="isAllowFileToAttachProfile"
                    [attachId]="profileAttachID"
                    [refreshAttachComponent]="isRefresh"
                    class="row"
                  >
                  </dg-file-upload>
                </div>
              </fieldset>
            </div>
            <div class="col-xl-8 col-lg-8 col-md-6 col-sm-6 col-xs-12">
              <div class="row">
                <div class="col-md-6 mt-1 common-form-field">
                  <mat-label class="common-label optional-field">{{
                    "user-registration.Salutation" | translate
                  }}</mat-label>
                  <ng-select
                    [items]="salutationList"
                    bindLabel="optionText"
                    [(ngModel)]="selectedSalutation"
                    placeholder="{{
                      'user-registration.Salutation' | translate
                    }}"
                    formControlName="salutation"
                  >
                  </ng-select>
                </div>
                <div class="col-md-6 mt-1">
                  <mat-form-field>
                    <mat-label class="required-field">{{
                      "user-registration.First_Name" | translate
                    }}</mat-label>
                    <input sanitized
                      matInput
                      id="firstname"
                      type="text"
                      formControlName="empFirstName"
                    />
                    <mat-error>{{
                      "user-registration.Error_First_Name" | translate
                    }}</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-6 mt-4">
                  <mat-form-field>
                    <mat-label>{{
                      "user-registration.Middle_Name" | translate
                    }}</mat-label>
                    <input sanitized
                      matInput
                      id="middlename"
                      type="text"
                      formControlName="empMiddleName"
                    />
                    <mat-error>{{
                      "user-registration.Error_Middle_Name" | translate
                    }}</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-6 mt-4">
                  <mat-form-field>
                    <mat-label class="required-field">{{
                      "user-registration.Last_Name" | translate
                    }}</mat-label>
                    <input sanitized
                      matInput
                      id="lastname"
                      type="text"
                      formControlName="empLastName"
                    />
                    <mat-error>{{
                      "user-registration.Error_Last_Name" | translate
                    }}</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-6 mt-4">
                  <mat-label class="dark-grey required-field">{{
                    "user-registration.Gender" | translate
                  }}</mat-label>
                  <div class="mt-1">
                    <mat-radio-group
                      [(ngModel)]="selectedGen"
                      formControlName="gender"
                      #radioGroup="matRadioGroup"
                    >
                      <mat-radio-button value="1">{{
                        "user-registration.Male" | translate
                      }}</mat-radio-button>
                      <mat-radio-button value="2">{{
                        "user-registration.Female" | translate
                      }}</mat-radio-button>
                      <mat-radio-button value="3">{{
                        "user-registration.Others" | translate
                      }}</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
                <div class="col-md-6 mt-4">
                  <mat-form-field>
                    <mat-label>{{
                      "user-registration.Mobile_Number" | translate
                    }}</mat-label>
                    <input sanitized
                      matInput
                      type="text"
                      id="phone"
                      formControlName="mobileNo"
                      mask="0000000000"
                    />
                    <mat-error>{{
                      "user-registration.Error_Mobile_Number" | translate
                    }}</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-6">
                  <mat-form-field class="mt-4">
                    <mat-label class="required-field">{{
                      "user-registration.DOB" | translate
                    }}</mat-label>
                    <input sanitized
                      matInput
                      [matDatepicker]="picker1"
                      id="dob"
                      formControlName="dob"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="picker1"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                  </mat-form-field>
                </div>
                <div class="col-md-6 mt-4">
                  <mat-label class="required-field common-label"
                    >Reporting Employee</mat-label
                  >
                  <dg-employee-search
                    #empSearch
                    [empConfig]="empSearchConfig"
                    [orgConfig]="orgConfig"
                    [selectedEmployeeList]="existingEmployeeUnitList"
                    (output)="getEmpData($event)"
                  >
                    <ng-container class="employee-search-header-text">
                      {{ "user-registration.Reporting_Employee" | translate }}
                    </ng-container>
                  </dg-employee-search>
                </div>
              </div>
            </div>
            <div class="col-md-12" *ngIf="false">
              <div class="row mt-2">
                <div class="col-md-3" *ngIf="false">
                  <mat-form-field>
                    <mat-label class="required-field">{{
                      "user-registration.DOR" | translate
                    }}</mat-label>
                    <input sanitized
                      matInput
                      [matDatepicker]="picker2"
                      id="dor"
                      formControlName="dor"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="picker2"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #picker2></mat-datepicker>
                  </mat-form-field>
                </div>
                <div class="col-md-3 common-form-field" *ngIf="false">
                  <dg-org-search
                    #orgSearch
                    [orgConfig]="orgConfig"
                    (output)="getOrgData($event)"
                  ></dg-org-search>
                </div>
                <div class="col-md-3">
                  <span class="pe-4" *ngFor="let item of roleList">
                    <mat-checkbox
                      formControlName="role"
                      [checked]="item.isChecked"
                      value="item.value"
                      (change)="toggle(item.value)"
                    >
                      {{ item.value }}
                    </mat-checkbox>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="true" *ngIf="false">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span>{{
              "user-registration.Address_Details" | translate
            }}</span></mat-panel-title
          >
        </mat-expansion-panel-header>
        <div class="col-md-12 w-100">
          <dg-address
            [addressType]="2"
            [addressCode]="addressCode"
            (output)="getAddressOutput($event)"
          ></dg-address>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="true" *ngIf="false">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span>{{
              "user-registration.Role" | translate
            }}</span></mat-panel-title
          >
        </mat-expansion-panel-header>
        <div class="col-md-12">
          <div>
            <span class="pe-4" *ngFor="let item of roleList">
              <mat-checkbox
                formControlName="role"
                [checked]="item.isChecked"
                value="item.value"
                (change)="toggle(item.value)"
              >
                {{ item.value }}
              </mat-checkbox>
            </span>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</form>
<div *ngIf="showButtons" class="my-2">
  <button
    color="primary"
    mat-raised-button
    (click)="submit()"
    [disabled]="expForm.invalid"
    class="me-2"
  >
    {{ "user-registration.Submit" | translate }}
  </button>
  <button mat-raised-button (click)="saveAsDraft()" class="me-2">
    {{ "user-registration.Save_Draft" | translate }}
  </button>
  <button mat-raised-button (click)="onReset()" class="me-2">
    {{ "user-registration.Reset" | translate }}
  </button>
  <button mat-raised-button (click)="onCancel()">
    {{ "user-registration.Cancel" | translate }}
  </button>
</div>
